const taskProjectStorage = {
  state: {
    singleDelete: null,
    statusChangedId: null,
    statusId: null,
    priorityChangedId: null,
    priorityId: null,
    singleDeleteLive: null,
    updateTaskInProjectKanban: false,
    addedData: null,
    userList: [],
    showButtonUser: false,
    clientList: [],
    showButtonClient: false,
    currentPageUser:'',
    currentPageClient:'',
    priorityList: [],
    liveTaskImportData: [],
    importMeta: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    tagsList: [],
    tag_meta: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    parentTaskData: [],
    sub_meta: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    meta_template: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    meta_task: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    ListOfTaskUpdate: [],
    ListOfLiveTaskUpdate: [],
    leadList: [],
    leadMeta: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    },
    ListOfProject: [],
    fetchRepoId: '',
    meta: {
      current_page: 1,
      has_next: true,
      limit: 20,
      next_page_url: '',
      previous_page_url: null,
      total: null
    }
  },
  mutations: {
    SET_DELETE_ID_MUTATION: (state, payload) => {
      state.singleDelete = payload
    },
    UPDATE_STATUS_ID_MUTATION: (state, payload) => {
      state.statusId = payload
    },
    UPDATE_STATUS_MUTATION: (state, payload) => {
      state.statusChangedId = payload
    },
    UPDATE_PRIORITY_MUTATION: (state, payload) => {
      state.priorityChangedId = payload
    },
    UPDATE_PRIORITY_ID_MUTATION: (state, payload) => {
      state.priorityId = payload
    },
    SET_UPDATE_DATA_MUTATION: (state, payload) => {
      state.updateTaskInProjectKanban = payload
    },
    SET_DELETE_LIVE_ID_MUTATION: (state, payload) => {
      state.singleDeleteLive = payload
    },
    SET_ADDED_ID_MUTATION: (state, payload) => {
      state.addedData = payload
    },
    UPDATE_USER_LIST: (state, payload) => {
      state.userList = payload.userList
      state.showButtonUser = payload.showButtonUser
      state.currentPageUser = payload.currentPageUser
    },
    UPDATE_CLIENT_LIST: (state, payload) => {
      state.clientList = payload.clientList
      state.showButtonClient = payload.showButtonClient
      state.currentPageClient = payload.currentPageClient
    },
    UPDATE_PRIORITY_LIST: (state, payload) => {
      state.priorityList = payload.priority
    },
    UPDATE_TAG_LIST: (state, payload) => {
      state.tagsList = payload.tagsList
      state.tag_meta = payload.tag_meta
    },
    UPDATE_PARENT_LIST: (state, payload) => {
      state.parentTaskData = payload.parentTaskData
      state.sub_meta = payload.sub_meta
    },
    UPDATE_TEMPLATE_LIST: (state, payload) => {
      state.ListOfTaskUpdate = payload.ListOfTaskUpdate
      state.meta_template = payload.meta_template
    },
    UPDATE_LIVE_LIST: (state, payload) => {
      state.ListOfLiveTaskUpdate = payload.ListOfLiveTaskUpdate
      state.meta_task = payload.meta_task
    },
    UPDATE_LEAD_LIST: (state, payload) => {
      state.leadList = payload.leadList
      state.leadMeta = payload.leadMeta
    },
    UPDATE_PROJECT_LIST: (state, payload) => {
      state.ListOfProject = payload.ListOfProject
      state.meta = payload.meta
    },
    UPDATE_IMPORT_LIST: (state, payload) => {
      console.log(payload.liveTaskImportData)
      state.liveTaskImportData = payload.liveTaskImportData
      state.importMeta = payload.meta
    },
    UPDATE_REPO_ID: (state, payload) => {
      state.fetchRepoId = payload.fetchRepoId
    }

  },
  actions: {
    SET_DELETE_ID:({commit}, payload) => {
      commit('SET_DELETE_ID_MUTATION', payload)
    },
    SET_STATUS:({commit}, payload) => {
      commit('UPDATE_STATUS_MUTATION', payload)
    },
    SET_STATUS_ID:({commit}, payload) => {
      commit('UPDATE_STATUS_ID_MUTATION', payload)
    },
    SET_PRIORITY_ID:({commit}, payload) => {
      commit('UPDATE_PRIORITY_ID_MUTATION', payload)
    },
    SET_PRIORITY:({commit}, payload) => {
      commit('UPDATE_PRIORITY_MUTATION', payload)
    },
    SET_UPDATE_DATA:({commit}, payload) => {
      commit('SET_UPDATE_DATA_MUTATION', payload)
    },
    SET_DELETE_LIVE_ID:({commit}, payload) => {
      commit('SET_DELETE_LIVE_ID_MUTATION', payload)
    },
    SET_ADD_ID:({commit}, payload) => {
      commit('SET_ADDED_ID_MUTATION', payload)
    }   
  },
  getters: {
    get_task_deleted_id: (state) => {
      return state.singleDelete
    },
    get_status_changes: (state) => {
      return state.statusChangedId
    },
    get_priority_changes: (state) => {
      return state.priorityChangedId
    },
    get_priority_id: (state) => {
      return state.priorityId
    },
    get_status_id: (state) => {
      return state.statusId
    },
    get_update_data: (state) => {
      return state.updateTaskInProjectKanban
    },
    get_task_deleted_live_id: (state) => {
      return state.singleDeleteLive
    },
    get_task_added_id: (state) => {
      return state.addedData
    },
    getGlobalUserList (state) {
      return state.userList
    },
    getGlobalClientList (state) {
      return state.clientList
    },
    getGlobalPriorityList (state) {
      return state.priorityList
    },
    getGlobalTagList (state) {
      return state.tagsList
    },
    getGlobalParentList (state) {
      return state.parentTaskData
    },
    getGlobalUpdatedTaskList (state) {
      return state.updatedTaskList
    },
    getGlobalLeadList (state) {
      return state.leadList
    },
    getShowButtonUser (state) {
      return state.showButtonUser
    }, 
    getCurrentPageUser (state) {
      return state.currentPageUser
    },
    getcurrentPageClient (state) {
      return state.currentPageClient
    },
    getShowButtonClient (state) {
      return state.showButtonClient
    },
    getTagMeta (state) {
      return state.tag_meta
    },
    getSubMeta (state) {
      return state.sub_meta
    },
    getMetaTemplate (state) {
      return state.meta_template
    },
    getMetaTask (state) {
      return state.meta_task
    },
    getListOfTaskUpdate (state) {
      return state.ListOfTaskUpdate
    },
    getListOfLiveTaskUpdate (state) {
      return state.ListOfLiveTaskUpdate
    },
    getLeadMeta (state) {
      return state.leadMeta
    },
    getListOfProject (state) {
      return state.ListOfProject
    },
    getMeta (state) {
      return state.meta
    },
    getGlobalImportedList (state) {
      console.log(state.liveTaskImportData)
      return state.liveTaskImportData
    },
    getImportedMeta (state) {
      return state.importMeta
    },
    getRepoId (state) {
      return state.fetchRepoId
    }
    
    
  }
}
export default taskProjectStorage